export default __webpack_public_path__ + "static/media/Ira.720f5c26.jpg";